<template>
  <div class="wrapper">
    <div class="searchBar">
      <div>
        <el-input
          placeholder="搜索学院姓名、手机号、证书名称、身份证号"
          size="small"
          style="width: 160px"
          v-model="searchCondition.search"
        ></el-input>
        &ensp;&ensp;
        <el-select
          placeholder="审核状态"
          v-model="searchCondition.reviewStatus"
          size="small"
        >
          <el-option value="" label="所有审核状态"></el-option>
          <el-option value="1" label="待审核"></el-option>
          <el-option value="2" label="审核通过"></el-option>
          <el-option value="3" label="审核不通过"></el-option>
        </el-select>
      </div>
      <div>
        <el-date-picker
          style="width: 200px"
          size="small"
          v-model="searchCondition.rangeTime"
          type="daterange"
          unlink-panels
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="
            (value) => {
              [searchCondition.startTime, searchCondition.endTime] = value || [
                '',
                '',
              ];
            }
          "
        >
        </el-date-picker>
        <!-- <el-date-picker
          type="date"
          placeholder="上传登记时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          size="small"
          v-model="searchCondition.createTime"
        >
        </el-date-picker> -->
        &ensp;&ensp;&ensp;&ensp;
        <el-button type="primary" size="small" @click="getData">查询</el-button>
      </div>
    </div>
    <div class="content">
      <div class="actBar">
        <div>
          <el-dropdown trigger="click" class="reviewBar">
            <el-button type="primary">导出</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-button
                  type="primary"
                  size="small"
                  @click="exportData(false)"
                  :disabled="selectList.length == 0"
                >
                  导出勾选数据</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button type="primary" size="small" @click="exportData(true)"
                  >导出当前筛选所有数据</el-button
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button>导出</el-button> -->
        </div>
        <div>
          <el-button
            slot="reference"
            :disabled="selectList.length == 0"
            @click="
              auditDialogIfShow = true;
              reviewRemark = '';
              auditData = null;
            "
            >审核</el-button
          >
        </div>
      </div>
      <div class="tableContainer">
        <el-table
          :data="dataList"
          @selection-change="
            (e) => {
              selectList = e;
            }
          "
          border
          style="width: 100%"
          ref="transformTable"
          :cell-style="{ padding: '8px 0', fontSize: '14px' }"
        >
          <el-table-column type="selection" width="40px"> </el-table-column>
          <el-table-column prop="userName" label="学员姓名" width="80px">
          </el-table-column>

          <el-table-column
            prop="certificateName"
            label="证书名称"
            width="120px"
          >
          </el-table-column>

          <el-table-column prop="certificateNum" label="证书编号" width="160px">
          </el-table-column
          ><el-table-column prop="award" label="颁发机构" min-width="160px">
          </el-table-column
          ><el-table-column prop="validity" label="有效期" width="100px">
          </el-table-column>
          <el-table-column prop="mobile" label="手机号" width="120px">
          </el-table-column>
          <el-table-column prop="createTime" label="上传登记时间" width="100px">
          </el-table-column
          ><el-table-column
            label="审核状态"
            width="100px"
            :formatter="
              (row) => [, '待审核', '审核通过', '审核不通过'][row.reviewStatus]
            "
          >
          </el-table-column>
          <el-table-column
            prop="reviewRemark"
            label="审核意见"
            min-width="100px"
          >
          </el-table-column>
          <el-table-column align="center" width="150">
            <template slot-scope="{ row }">
              <el-button
                :disabled="!row.certtificateImage"
                size="small"
                @click="previewImage([row.certtificateImage])"
              >
                预览</el-button
              >&ensp;

              <el-button
                slot="reference"
                size="small"
                :disabled="!(row.reviewStatus == 1)"
                @click="
                  auditDialogIfShow = true;
                  reviewRemark = '';
                  auditData = row;
                "
                >审核</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @current-change="getData"
          @size-change="getData"
          :current-page.sync="searchCondition.pageNumber"
          :page-sizes="[10, 30, 100]"
          :page-size.sync="searchCondition.pageSize"
          :total="searchCondition.total"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </div>
    <el-image-viewer
      v-if="previewImageList.length > 0"
      :on-close="
        () => {
          previewImageList = [];
        }
      "
      :url-list="previewImageList"
    />
    <el-dialog
      title="提示"
      append-to-body
      :visible.sync="auditDialogIfShow"
      width="40%"
    >
      <div class="dialogContent">
        <el-input
          placeholder="请输入审核意见"
          v-model="reviewRemark"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="auditSubmit(2)"
          >通过</el-button
        >
        <el-button size="small" type="danger" @click="auditSubmit(3)"
          >拒绝</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import elImageViewer from "element-ui/packages/image/src/image-viewer";
import Util from "@/libs/util";
import {
  CertificateTransformList,
  certificateTransformAudit,
  exportCertificateTransform,
} from "@/api/certificate.js";
export default {
  data() {
    return {
      dataList: [],
      selectList: [],
      previewImageList: [],
      searchCondition: {
        pageNumber: 1,
        pageSize: 10,
        search: "",
        reviewStatus: "",
        rangeTime: "",
        startTime: "",
        endTime: "",
        createTime: "",
      },
      auditLock: false,
      auditDialogIfShow: false,
      reviewRemark: "",
      auditData: {},
    };
  },
  components: { elImageViewer },
  methods: {
    exportData(ifAll) {
      if (ifAll) {
        window.location.href = Util.initUrl(
          "/base/common/userChangeCertificateListExport",
          this.searchCondition
        );
      } else {
        // console.log(this.selectList.map((item) => item.id));
        window.location.href = Util.initUrl(
          "/base/common/userChangeCertificateListExport",
          { ids: this.selectList.map((item) => item.id) }
        );
      }
    },
    previewImage(urlList) {
      if (urlList[0]) {
        this.previewImageList = urlList;
      } else {
        this.$message.warning("此申请没有提供图片数据");
      }
    },
    getData() {
      CertificateTransformList(this.searchCondition).then((data) => {
        // data.rows.forEach((item) => {
        //   item.reviewRemark = "";
        // });
        this.dataList = data.rows;
        this.searchCondition.total = data.total;
        this.auditLock = false;
      });
    },
    auditSubmit(status) {
      if (this.auditLock) {
        return;
      }

      this.auditLock = true;
      let item = this.auditData || null;
      if (item) {
        certificateTransformAudit({
          ids: [item.usercertificateId],
          reviewStatus: status,
          reviewRemark: this.reviewRemark,
        }).then((data) => {
          this.$message.success("审核成功");
          this.getData();
          this.auditDialogIfShow = false;
        });
      } else {
        certificateTransformAudit({
          ids: this.selectList.map((item) => item.usercertificateId),
          reviewRemark: this.reviewRemark,
          reviewStatus: status,
        }).then((data) => {
          this.$message.success("审核成功");
          this.getData();
          this.auditDialogIfShow = false;
        });
      }
    },
  },
  created() {},
  mounted() {
    this.getData();
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .searchBar {
    padding: 15px;
    background: #fff;
    display: flex;
    justify-content: space-between;
  }
  .content {
    margin-top: 15px;
    background: #fff;
    padding: 15px;
    .actBar {
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }
  }
}
/deep/ .el-range-editor--small .el-range-input {
  width: 70px;
}
/deep/ .el-date-editor .el-range-separator {
  width: auto;
  padding: 0;
}
</style>
